import React, { useState, useRef, useEffect, useContext } from 'react';
import { Drawer, Button, Input, Spin, Row, Col } from 'antd';
import { ArrowLeftOutlined, ArrowRightOutlined, AudioOutlined, LoadingOutlined, SendOutlined } from '@ant-design/icons';
import { marked } from 'marked';
import DOMPurify from 'dompurify';
import './PhysioChat.css';

import { emptyPatient, Patient } from "../patients/interfaces";
import { SignedInDoctor } from '../auth/interfaces';
import { SignedInContext } from '../AppEnv';
import { getPatient } from '../patients/utils';
import { useLocation, useParams } from 'react-router-dom';
import { getPosturalExamData, getPosturalExamDefinition } from '../exams/utils';


// API KEY OPENAI - lettura da variabili d'ambiente
const API_KEY = process.env.REACT_APP_API_KEY || '';

type PhysioChatProps = {
    patientId?: string;  // l’ID in formato string
};


const PhysioChat: React.FC<PhysioChatProps> = () => {
    const [open, setOpen] = useState(false);
    const { } = useParams();
    const [patient, setPatient] = useState(emptyPatient);
    const [messages, setMessages] = useState<string[]>([]);
    const [inputValue, setInputValue] = useState('');
    const [inputValuePlus, setInputValuePlus] = useState('');
    const [inputValuePlus2, setInputValuePlus2] = useState('');
    const [inputValuePlus3, setInputValuePlus3] = useState('');
    const [inputValuePlus4, setInputValuePlus4] = useState('');
    
    const [inputValueSet, setInputValueSet] = useState('');
    
    const [loading, setLoading] = useState(false);
    const [threadId, setThreadId] = useState<string | null>(null);
    
    const messagesEndRef = useRef<HTMLDivElement>(null);
    const [checkedId, setCheckedId] = useState<boolean>(false);
    const [checkedExam, setCheckedExam] = useState<boolean>(false);
    const [checked, setChecked] = useState<boolean>(false);
    const [checked2, setChecked2] = useState<boolean>(false);
    const [checked3, setChecked3] = useState<boolean>(false);
    const [checked4, setChecked4] = useState<boolean>(false);
    const toggleChat = () => setOpen(!open);
    const [patientIdUrl , setPatientIdUrl] = useState<number | undefined>(undefined);
    const [examIdUrl , setExamIdUrl] = useState<number | undefined>(undefined);
    
    const [examNote , setExamNote] = useState<string | undefined>(undefined);


const currentUrl = window.location.href;
const urlParts = currentUrl.split('/');
const patientIdFromUrl = urlParts[urlParts.indexOf('patients') + 1];


let examIdFromUrl = urlParts[urlParts.indexOf('patients') + 2];
if (examIdFromUrl && examIdFromUrl.includes('?')) {
    examIdFromUrl = examIdFromUrl.split('?')[0];
}


const location = useLocation();
// console.log(`Patientrvebdnwxs: ${examIdFromUrl}`);



//FOR EXAM
useEffect(() => {
    setExamIdUrl(Number(examIdFromUrl));

    const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

    if ((Number(examIdFromUrl) ?? -1) > -1) {
        setInputValueSet(patient.name);
        setCheckedExam(true);
    } else {
        setCheckedExam(false);
    }
}, [location, patient.id, setInputValueSet, setCheckedId, inputValuePlus]); // assicurati di includere le dipendenze necessarie

useEffect(() => {
    const fetchPosturalExamDefinition = async () => {
        const examDefinition = await getPosturalExamDefinition(signedInDoctor, 'someExamType');
        //  console.log('Postural Exam Definition:', examDefinition);
        setExamNote(JSON.stringify(examDefinition));
    };

    fetchPosturalExamDefinition();
}, []);


// console.log(`Patientrvebdnwxs: ${patientIdFromUrl}`);
useEffect(() => {
    const fetchPosturalExamData = async () => {
        if (patientIdUrl !== undefined && examIdUrl !== undefined) {
            const examData = await getPosturalExamData(signedInDoctor, patientIdUrl, examIdUrl);
            //console.log('Postural Exam Data:', examData);
            if (examData && examData.testSelections) {
                const notes = examData.testSelections.map((selection: any) => selection.note).join(', ');
                setExamNote(notes);
            }
          //console.log("NOTE: " + examNote)
        }
    }

    fetchPosturalExamData();
}, [examIdUrl]);

useEffect(() => {
    setPatientIdUrl(Number(patientIdFromUrl));
    // Questo effetto verrà eseguito ogni volta che l'URL cambia
    // console.log('URL changed:', location.pathname);
    // console.log("ENTRATO IN USEEFFECT!!!")
    // console.log("PATIENT ID URL:", patientIdUrl);
    const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

    const fetchPatientData = async () => {
        await delay(500); // Pausa di mezzo secondo
        const idInt: number = parseInt(patientIdFromUrl || "-1");
        getPatient(signedInDoctor, idInt, (idInt > 0))
            .then((fetchedPatient: Patient) => {
                setPatient({
                    ...fetchedPatient,
                });
            })
            .catch((err) => console.error(err));
    };

    fetchPatientData();
    // Esegui il processo che desideri
    if ((patientIdUrl ?? -1) > -1) {
      // console.log("ID PAT:", patient.id);
      setInputValueSet(patient.name);
      // console.log("PATIENT NAME:", inputValuePlus); // attento: inputValuePlus potrebbe non essere ancora aggiornato
      setCheckedId(true);
    } else {
      setCheckedId(false);
      setChecked(false);
      setChecked2(false);
      setChecked3(false);
      setChecked4(false);

    }
    // console.log("checked è:" + checkedId);
  }, [location, patient.id, setInputValueSet, setCheckedId, inputValuePlus]); // assicurati di includere le dipendenze necessarie


//setCheckedId(Number(patientIdFromUrl) > -1);

    const signedInDoctor: SignedInDoctor =
        useContext(SignedInContext).signedInDoctor;
    
        // console.log("Patient:", patient);
        // console.log("IDDDt:", id);
        
    useEffect(() => {
        // console.log("PhysioChat: " + patientId);
        
        const idInt:number = parseInt(patientIdFromUrl || "-1");
        getPatient(signedInDoctor, idInt, (idInt > 0))
          .then((fetchedPatient: Patient) => {
            setPatient({
              ...fetchedPatient,
            });
          })
          .catch((err) => console.error(err));
      }, [signedInDoctor]);

    
    


    const addInfoPatient = () => {
       
            
        
       
        
        setInputValuePlus(!checked ? ( "Dati Paziente: " +  "Nome e Cognome: " + patient.name + " " + patient.surname  + "Allergie: " + patient.allergies + ", Altezza: " + patient.height + ", Peso: " + patient.weight + ", Data di Nascita: " + patient.birthDate + ", Condizioni Pre-esistenti: " + patient.preexistingConditions) : '');
        setChecked(!checked);
        console.log("IPUNT!:  " + inputValuePlus);
        };

    
    
    const addInfoPatient2 = () => {
        setChecked2(!checked2);
        setInputValuePlus2(!checked2 ? ("Protocollo: " + `${patient.protocolExample}` || " ") : '');
        console.log("CHECKED IS: " + checked2 + " INPUT: " + inputValuePlus2) 
     };
   
    
    const addInfoPatient3 = () => {
        setChecked3(!checked3);
           
        
        setInputValuePlus3(!checked3 ? ( "Informazioni aggiuntive: "  + patient.additionalNotes + "Problematiche Rilevanti: " + patient.relevantIssues + ", Controindicazioni Strumentali: " + patient.avoidTools + ", Red-Falg: " + patient.redFlags ) : '');
        console.log( " | " +  inputValuePlus3);
    };

    const addInfoPatient4 = () => {
        setChecked4(!checked4);
           
    
        setInputValuePlus4(!checked4 ? (  "Dati Esame in Corso: " + examNote ) : '');
      
        console.log( " | " +  inputValuePlus4);
    };

 /*   const sendMessage = async () => {
        const userMessage = `Tu: ${inputValue}`;
        setMessages((prev) => [...prev, userMessage]);
        setInputValue('');
        setLoading(true);
        console.log("PROMPT INVIATO:   " + inputValue + "Informazioni aggiuntive: " + inputValuePlus + inputValuePlus2 + inputValuePlus3);
        const res = await fetch('https://api.openai.com/v1/chat/completions', {
            method: 'POST',
            headers: {
            'Authorization': `Bearer ${API_KEY}`,
            'Content-Type': 'application/json',
            },
            body: JSON.stringify({
            model: 'gpt-4',
            messages: [
                ...messages.slice(-7).map(msg => ({ role: msg.startsWith('Tu:') ? 'user' : 'assistant', content: msg.replace('Tu: ', '').replace('AI: ', '') })),
                { role: 'user', content: inputValue + "Informazioni aggiuntive: " + inputValuePlus + inputValuePlus2 + inputValuePlus3 },
            ],
            }),
        });
         
        const data = await res.json();
        
        setMessages((prev) => [...prev, `AI: ${data.choices[0].message.content}`]);
        setLoading(false);
    }; */
    

    const sendMessage = async () => {
        try {
            setLoading(true);
    
            const userMessage = `Tu: ${inputValue}`;
            setMessages((prev) => [...prev, userMessage]);
            setInputValue('');
    
            console.log("PROMPT INVIATO: " + inputValue + "  " + inputValuePlus + inputValuePlus2 + inputValuePlus3 + inputValuePlus4);
    
            let currentThreadId = threadId;
    
            // 1️⃣ Creazione del thread SOLO SE NON ESISTE
            if (!currentThreadId) {
                console.log("Creazione di un nuovo thread...");
                const threadRes = await fetch('https://api.openai.com/v1/threads', {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${API_KEY}`,
                        'Content-Type': 'application/json',
                        'OpenAI-Beta': 'assistants=v2'  // 🔥 Header richiesto
                    },
                    body: JSON.stringify({})
                });
    
                const threadData = await threadRes.json();
                if (!threadRes.ok) {
                    console.error("Errore nella creazione del thread:", threadData);
                    throw new Error(`Errore nella creazione del thread: ${JSON.stringify(threadData)}`);
                }
    
                currentThreadId = threadData.id;
                setThreadId(currentThreadId);
                console.log("✅ Thread creato con successo:", currentThreadId);
            }
    
            // 2️⃣ Aggiungere il messaggio dell'utente al thread
            await fetch(`https://api.openai.com/v1/threads/${currentThreadId}/messages`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${API_KEY}`,
                    'Content-Type': 'application/json',
                    'OpenAI-Beta': 'assistants=v2'  // 🔥 Header richiesto
                },
                body: JSON.stringify({
                    role: "user",
                    content: inputValue + " " + inputValuePlus + inputValuePlus2 + inputValuePlus3 + inputValuePlus4
                })
            });
    
            // 3️⃣ Avviare il run con l'assistant
            const runRes = await fetch(`https://api.openai.com/v1/threads/${currentThreadId}/runs`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${API_KEY}`,
                    'Content-Type': 'application/json',
                    'OpenAI-Beta': 'assistants=v2'  // 🔥 Header richiesto
                },
                body: JSON.stringify({
                    assistant_id: 'asst_zSBE4Ztm3Iu5oI99WMlBwUmo' 
                })
            });
    
            const runData = await runRes.json();
            const runId = runData.id;
    
            // 4️⃣ Attendere la risposta dell'assistente
            let runStatus = "in_progress";
            while (runStatus !== "completed") {
                await new Promise((resolve) => setTimeout(resolve, 2000)); // Aspettiamo 2 secondi tra le richieste
                const checkRunRes = await fetch(`https://api.openai.com/v1/threads/${currentThreadId}/runs/${runId}`, {
                    headers: {
                        'Authorization': `Bearer ${API_KEY}`,
                        'Content-Type': 'application/json',
                        'OpenAI-Beta': 'assistants=v2'  // 🔥 Header richiesto
                    }
                });
                const checkRunData = await checkRunRes.json();
                runStatus = checkRunData.status;
            }
    
            // 5️⃣ Recuperare la risposta dell'assistant
            const messagesRes = await fetch(`https://api.openai.com/v1/threads/${currentThreadId}/messages`, {
                headers: {
                    'Authorization': `Bearer ${API_KEY}`,
                    'Content-Type': 'application/json',
                    'OpenAI-Beta': 'assistants=v2'  // 🔥 Header richiesto
                }
            });
    
            const messagesData = await messagesRes.json();
            console.log("MESSAGGI RICEVUTI:", messagesData); // 🔍 Debug per vedere il formato della risposta
    
            // 6️⃣ Filtrare solo i messaggi dell'assistente e prendere l'ultimo
            const assistantMessages = messagesData.data.filter((msg: { role: string; }) => msg.role === "assistant");

if (assistantMessages.length > 0) {
    const firstMessage = assistantMessages[0]; // Primi messaggio dell'assistente
    console.log("Primo messaggio dell'assistente:", firstMessage.content[0].text.value);
    setMessages((prev) => [...prev, `AI: ${firstMessage.content[0].text.value}`]); // Aggiungi la risposta dell'assistente
} else {
    console.warn("⚠️ Nessuna risposta dall'assistente!");
}

            
            
    
            setLoading(false);
            //toglio selected items like dati ecc...
            setChecked(false);
            setChecked2(false);
            setChecked3(false);
            setChecked4(false);
            //svuota campi InputPlus
            setInputValuePlus('');  
            setInputValuePlus2('');
            setInputValuePlus3('');
            setInputValuePlus4('');  


        } catch (error) {
            console.error("❌ Errore durante la gestione del thread:", error);
            setLoading(false);
        }
    };
    
    

    

    const renderMessage = (msg: string, i: number) => {
        const isUser = msg.startsWith('Tu:');
        const rawMarkup = marked(msg.replace('Tu: ', '').replace('AI: ', '')) as string;
        const sanitizedMarkup = DOMPurify.sanitize(rawMarkup as string);

        return (
            <div
                key={i}
                style={{
                    alignSelf: isUser ? 'flex-end' : 'flex-start',
                    backgroundColor: isUser ?   'rgba(158, 220, 196, 0.54)' : 'rgba(167, 133, 169, 0.56)',
                    borderRadius: "20px",
                    padding: '10px 15px 0px 15px',
                    margin: '6px ',
                    maxWidth: '70%',
                    wordWrap: 'break-word',
                }}
                dangerouslySetInnerHTML={{ __html: sanitizedMarkup }}
            />
        );
    };

    useEffect(() => {
        if (!loading) {
            messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
        }
    }, [messages, loading]);



 


    return (
        <>
        
            <button
                onClick={toggleChat}
                className='physiochatbutton'
                style={{
                    borderRadius: "100px 0px 0px 100px",
                    height: "90px",
                    width: "35px",
                    border: "none",
                    position: 'fixed',
                    right: open ? 600 : 0,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    zIndex: 9999
                }}
            >
                {open ? <ArrowRightOutlined rev={undefined} /> : <ArrowLeftOutlined rev={undefined} />}
            </button>
            <Drawer
                style={{ borderRadius: "25px 0px 0px 25px ", zIndex: 9999999999999999 }}
                placement="right"
                title="Aurora Ai Assistant"
                open={open}
                className='physiochatdrawer'
                width={600}
                onClose={toggleChat}
                styles={{
                    header: {
                        background: 'linear-gradient(45deg,rgba(158, 220, 196, 0.54),rgba(209, 134, 58, 0.68), rgba(167, 133, 169, 0.56),rgba(119, 189, 151, 0.69),rgba(167, 133, 169, 0.56),rgba(184, 136, 218, 0.73),rgba(125, 202, 179, 0.62))',
                        backgroundSize: '1900% 2900%',
                        animation: 'rainbow 50s ease infinite', 
                    },
                    body: {
                        borderRadius: "25px 0px 0px 25px !important",
                        backgroundColor: 'transparent',
                        display: 'flex',
                        flexDirection: 'column',
                        padding: '25px',
                        height: '100%',
                    }
                }}
                mask={false} // Disattiva l'oscuramento dello schermo
            >
            
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflowY: 'auto' }}>
                    {messages.length === 0 && (
                        <>
                        <div style={{ alignSelf: 'center', margin: '20px 0', fontSize: '16px', color: '#888', textAlign: 'center' }}>
                            Buongiorno Dottore, come va?  <br /> In cosa posso esserti utile? 
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'space-around', margin: '20px 0', flexWrap: 'wrap' }}>
                            <Row style={{ display: 'flex', justifyContent: 'space-around', margin: '20px 0', overflowX: "hidden", maxWidth: "80%", flexWrap: 'wrap', position: 'absolute', bottom: '100px', left: '10%', right: '10%' }}>
                            <button
                                onClick={() => setInputValue("Dove posso trovare i dati relativi al mio paziente?")}
                                 className='physiochatbuttontxt'
                            >
                                Dove posso trovare i dati relativi al mio paziente?
                            </button>
                            <button
                                onClick={() => setInputValue("Il paziente si è presentato con una neoplasia importante come posso procedere?")}
                                 className='physiochatbuttontxt'
                            >
                                Il paziente si è presentato con una neoplasia importante come posso procedere?
                            </button>
                            <button
                                onClick={() => setInputValue("Ho bisogno di supporto per creare un protoccollo efficace per il paziete, ecco le sue problematiche: ")}
                               className='physiochatbuttontxt'
                            >
                                Ho bisogno di supporto per creare un protoccollo efficace per il paziete, ecco le sue problematiche:
                            </button>
                            </Row>
                        </div>
                        </>
                        
                    )}
                    {messages.map((msg, i) => renderMessage(msg, i))}
                    {loading && (
                        <div style={{ alignSelf: 'flex-start', margin: '6px 0' }}>
                            <Spin />
                        </div>
                    )}
                    <div ref={messagesEndRef} />
                </div>
                <Row>
                <Col span={20} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Input.TextArea
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    onPressEnter={(e) => {
                        if (!e.shiftKey) {
                            sendMessage();
                        }
                    }}
                    placeholder="Scrivi un messaggio..."
                    style={{ margin: '10px 0', width: '100%' }}
                    disabled={loading}
                    autoSize={{ minRows: 1, maxRows: 6 }}
                />
                </Col>
             
                
                <Col span={4} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Button type="primary" onClick={sendMessage} shape="circle" disabled={loading}>
            {!loading && <SendOutlined rev={undefined} />}
            {loading && <LoadingOutlined  rev={undefined} />}
                </Button>
                </Col>
               
                </Row>
            {checkedId && 
                <Row>
                <Col span={4} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div style={{ alignSelf: 'center', margin: '5px 0', fontSize: '16px', color: '#888', textAlign: 'center' }}>
                    Inserisci:     
                </div>
                </Col>
                <Col span={4} style={{  margin: '0 15px' }}>
                <Button  style={
        checked
          ? { color: "white", background: "#9edcc4" }
          : { color: "black", background: "#9edcc44d" }
      }
      onClick={() => addInfoPatient()}
    > Dati Paziente</Button>
                </Col>
                {checkedExam &&  
                <Col span={4} style={{  margin: '0 15px' }} >
                <Button  style={
        checked4
          ? { color: "white", background: "#9edcc4" }
          : { color: "black", background: "#9edcc44d" }
      }
      onClick={() => addInfoPatient4()}
    > Dati Esame</Button>
                </Col>
  }
                
                {!checkedExam && <Col span={4} style={{  margin: '0 15px' }}>
                <Button  style={
        checked2
          ? { color: "white", background: "#9edcc4" }
          : { color: "black", background: "#9edcc44d" }
      }
      onClick={() => addInfoPatient2()}
    > Protocollo </Button>
                </Col>
  }
                <Col span={4}>
                <Button  style={
        checked3
          ? { color: "white", background: "#9edcc4" }
          : { color: "black", background: "#9edcc44d" }
      }
      onClick={() => addInfoPatient3()}
    > Scheda Clinica</Button>
                </Col>

             
  
                </ Row>

            }

            </Drawer>
        </>
    );
};

export default PhysioChat;

function getExam(signedInDoctor: SignedInDoctor, idInt: number, arg2: boolean) {
    throw new Error('Function not implemented.');
}
function useSpeechRecognition({ onResult }: { onResult: (result: string) => void; }) {
    const listen = () => {
        // Implement speech recognition start logic here
    };
    const stop = () => {
        // Implement speech recognition stop logic here
    };
    const listening = false; // Implement logic to determine if listening

    return { listen, listening, stop };
}
